var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfflineTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "url(#pattern0_1942_1648)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1942_1648",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1942_1648",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1942_1648",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADfUlEQVR4nO2cvU5UURSFT8NfeAKjkel5CR9A4itMbCgEfAyxMUbsfRQ6wUawsJ5GJNFKh36Zkzkkh8n87HXn/Dl3fQkNOVl7nzXr7gtzf5wTQgghhBBCiHUDwDaA1wC+ALjD+nIH4BLACYCt0iY/AfAN/ePa771kkvtocmx2/mSHcdF3jksY7Wdy37koYfS49i4bYFzCaAFARhdCRhci99gYGno4N+gMcmzG6NHAoHNu0Bmy/Vk3sW/8D/BZog8MHXpECoP8Hgw63ot9tsdlhXcBfE+RZg+ATxZHHIlF09c2allS7T3ZZftc2RhLmj0ARhYxR2LscWTUsqTa/MG5VIc5keaBUS+X0aY5TaR69XlNzGUmzUOrGx36RUpjiFR3n9fEXDanmRxDOY02H+5EqrvNa8YQa5qZ+exxJES/I0LTmmp+XjOHN5nmAaGb02jznCZTbZ/X5Fxm0zxknLDqRvoMw0ypXj6vyblMpbnDOMptNHWYk6lePK9ZI5g0s/PZ40jI3kekNpPqxR8k+V3znw5GjBvS/1utf/LqCX2VAW3pX1brP1xSt3LUodGThvSPq/Xvr+6Gq7zLuAKw2aHRLek/vGfjeonJj1mTG9L/CuBRE/2H5B37ORNOAP7nsz8cuiS5Ef2LoL/Vev9CCCH+AwBsAHgJ4JXl5AJgE8Ch9WQUTjZHhD67fjusP7ScvCJ9v+cNlwsAOwCeAjgA8A7ATfTnzC8AZwBehK9Bd6bWvwdwO2f9XrR+L/zuLKyJ139IsH4QfvcRwO9o/W3o8SD0PL1+Wv8mePD8fn1Ko8UCZHQhZHQhZHQhZHQhZHQhZHQhZHQhZPS6G52scEQLtWR0YmT0DFKbLKPnIKMLpcwVrJW9h2qFI1qoJaMTI6NnkNpkGT0HGV0oZa5grew9VCsc0UItGZ2YtTUak9sR3gL4Ga4yn07fBmCpZdFpYb/VCmNiyDSnlh5YnRb2W60wJgmc5tbSA6vTwn6rFcbDG3Lu+WHpgdVpYb/VCmP2If/G0gOr08J+qxXG5CR2GhK56slwoU4L+22vcEQLtWR0YmT0DFKbLKPnIKMLpcwVrJW9h2qFI/pi9LhK4YgWaqV6OUCyVxknKxzRQq3srzgmHzbvm9FHKQtbH5bvm9FXyR9JNjxs3jejr1Z5OQD7sHn1zbuCtfRwvRBCCCGEEMKtI/8AKWS1+xAZDswAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineTag);
export default __webpack_public_path__ + "static/media/offlineTag.5a6c8379f3c22398713dc34a0fab3217.svg";
export { ForwardRef as ReactComponent };